<script>
	import { DialogNew } from '@shopboxai/sb-portal-components';
	import PageTypeSelect from '../../PageTypeSelect.svelte';
	import { id } from '../../../utils/utils.js';
	export let data = {
		name: '',
		id: id(),
		page_type: '',
		mobile: {
			items: [
				{
					type: 'collection',
					size: 1,
					title: 'Promotions For You',
					collection: 'promotions_for_you',
					fallback: 'top_viewed_offer_products',
					fallback_title: 'Promotions',
					num_products: 4,
					device: 'desktop',
					id: id()
				},
				{
					type: 'collection',
					size: 1,
					title: 'New For You',
					collection: 'new_for_you',
					fallback: 'top_viewed_new_products',
					fallback_title: 'New',
					num_products: 4,
					device: 'desktop',
					id: id()
				},
				{
					type: 'collection',
					size: 1,
					title: 'Recommended For You ',
					collection: 'recommendations',
					fallback: 'trending_view_products',
					fallback_title: 'Top Trending',
					num_products: 4,
					device: 'desktop',
					id: id()
				},
				{
					type: 'collection',
					size: 1,
					title: 'Recently Viewed',
					collection: 'recently_viewed',
					fallback: 'top_viewed',
					fallback_title: 'Top Viewed',
					num_products: 4,
					device: 'desktop',
					id: id()
				}
			]
		},
		desktop: {
			items: [
				{
					type: 'collection',
					size: 2,
					title: 'Promotions For You',
					collection: 'promotions_for_you',
					fallback: 'top_viewed_offer_products',
					fallback_title: 'Promotions',
					num_products: 3,
					device: 'desktop',
					id: id()
				},
				{
					type: 'collection',
					size: 2,
					title: 'New For You',
					collection: 'new_for_you',
					fallback: 'top_viewed_new_products',
					fallback_title: 'New',
					num_products: 3,
					device: 'desktop',
					id: id()
				},
				{
					type: 'collection',
					size: 2,
					title: 'Recommended For You ',
					collection: 'recommendations',
					fallback: 'trending_view_products',
					fallback_title: 'Top Trending',
					num_products: 3,
					device: 'desktop',
					id: id()
				},
				{
					type: 'collection',
					size: 2,
					title: 'Recently Viewed',
					collection: 'recently_viewed',
					fallback: 'top_viewed',
					fallback_title: 'Top Viewed',
					num_products: 3,
					device: 'desktop',
					id: id()
				}
			]
		}
	};
</script>

<DialogNew {data} on:submit on:close>
	<div slot="header">Add name for the new grid</div>
	<div slot="content" class="dialog-form-wrapper">
		<input type="hidden" name="id" bind:value={data.id} />
		<label for="title">Grid Name</label>
		<input id="title" type="text" bind:value={data.name} required />
		<PageTypeSelect bind:value={data.page_type} />
	</div>
	<button slot="toggle" class="create-button">
		<svg viewBox="152.124 82.083 64 42" width="64" height="42">
			<rect width="64" height="42" fill="var(--bg-c)" x="152.124" y="82.083" style="" />
			<rect x="185.004" y="84.484" width="27" height="17.797" fill="#c1ece6" style="" />
			<rect x="156.197" y="84.573" width="27" height="17.797" fill="#c1ece6" style="" />
			<rect x="184.953" y="103.905" width="27" height="17.797" fill="#c1ece6" style="" />
			<rect x="156.145" y="103.969" width="27" height="17.797" fill="#c1ece6" style="" />
		</svg>

		<div>
			<h4>Full Layout</h4>
			<p>recommendations, top viewed, new for you, recently viewed</p>
		</div>
	</button>
</DialogNew>

<style>
</style>
